<!-- =========================================================================================
    File Name: VxTimeline.vue
    Description: Timeline Component
    Component Name: VxTimeline
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <ul class="vx-timeline">
      <li v-for="item in timelineData" :key="item.id">
          
            <div :class="`timeline-icon ${ item.activity_type }`">
              <vs-tooltip :text="item.activity_type">
                <span :class="`material-icons-outlined ${ item.activity_type }-text`">
                  {{ renderIcon (item.activity_type) }}
                </span>
              </vs-tooltip>
            </div>
          
          <div class="timeline-info">
              <div class="flex flex-1 justify-between">
                <p class="font-semibold">{{ getDescription(item) }}</p>
                <small class="text-grey activity-e-time">{{ item.created_at | formatTimeAgo }}</small>
              </div>
              <span class="activity-desc">{{ item.comment }}</span>
              <div class="flex flex-1 mt-4 chip_row">
                <vs-chip color="success" v-if="item.activity_result_id == 1">
                  Interested
                </vs-chip>
                <vs-chip color="danger" v-if="item.activity_result_id == 3">
                  Not Interested
                </vs-chip>
                <vs-chip  v-if="item.activity_result_id == 2">
                  Not Decided
                </vs-chip>

                <vs-chip class="reminder_date_time_chip" v-if="item.has_reminder">
                  {{ item.reminder_date | dateFormatLocalization }} at {{ `${item.reminder_date} ${item.reminder_time}` | timeFormatLocalization }}
                </vs-chip>
                <vs-tooltip v-if="item.has_reminder" :text="item.reminder_note">
                  <vs-chip class="reminder_note_chip">
                    {{ item.reminder_note | truncateString }}
                  </vs-chip>
                </vs-tooltip>
              </div>

          </div>
          
      </li>
  </ul>
</template>

<script>
export default {
  name: 'vx-timeline',
  props: {
    timelineData: {
      type: Array,
      required: true
    }
  },
  watch: {
    timelineData (newValue) {
      return newValue
    }
  },
  filters: {
    truncateString (value) {
      if (value.length > 36) {
        return `${value.substring(0, 36)  }  ...more`
      } else {
        return value
      }
    }
  },
  methods: {
    renderIcon (activity_type) {
      const iconSet = [
        { type: 'Create', icon: 'supervised_user_circle' },
        { type: 'Edit', icon: 'supervised_user_circle' },
        { type: 'CertificateShare', icon: 'verified' },
        { type: 'ShareGradebook', icon: 'star_outline' },
        { type: 'enroll', icon: 'badge' },
        { type: 'assignmentSubmit', icon: 'bookmarks'}
      ]

      return iconSet.find(activity => activity.type === activity_type).icon
    },
    getDescription (item) {
      const action_person_name = `${item.user_details.first_name} ${item.user_details.middle_name} ${item.user_details.last_name}`

      if (item.activity_type === 'Create') {
        return `Student has been created by ${action_person_name}`
      } else if (item.activity_type === 'Edit') {
        return `Student has been edited by ${action_person_name}`
      } else if (item.activity_type === 'CertificateShare') {
        return `Certificate has been shared by ${action_person_name}`
      } else if (item.activity_type === 'ShareGradebook') {
        return `Gradebook has been shared by ${action_person_name}`
      } else {
        return item.description
      }
    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>
<style>
  .timeline-icon {
    background-color: #FFFFFF !important;
    border: 1px solid;
  }

  .activity-e-time {
    min-width: 71px !important;
  }

  .chip_row > .con-vs-chip {
    cursor: default;
  }

  .reminder_date_time_chip {
    color: rgba(var(--vs-primary), 1) !important;
  }

  .reminder_note_chip {
    cursor: default;
  }

  .chat {
    border-color: rgba(var(--vs-success), 1) 
  }

  .chat-text {
    color: rgba(var(--vs-success), 1) 
  }

  .note {
    border-color: rgba(var(--vs-secondary), 1) 
  }

  .note-text {
    color: rgba(var(--vs-secondary), 1) 
  }

  .email {
    border-color: rgba(var(--vs-warning), 1) 
  }

  .email-text {
    color: rgba(var(--vs-warning), 1) 
  }

  .sms {
    border-color: rgba(var(--vs-danger), 1) 
  }

  .sms-text {
    color: rgba(var(--vs-danger), 1) 
  }

  .call {
    border-color: rgba(var(--vs-primary), 1) 
  }

  .call-text {
    color: rgba(var(--vs-primary), 1) 
  }

</style>